export default "__VITE_ASSET__Dnf5EvSi__"